import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-visible-fee-filters',
  templateUrl: './visible-fee-filters.component.html',
  styleUrls: ['./visible-fee-filters.component.scss']
})
export class VisibleFeeFiltersComponent implements OnInit {

  responseType = [
    {value: 'yes', description: 'Yes'},
    {value: 'no', description: 'No'},
  ];

  searchForm = this.formBuilder.group({
    responseType: [''],
  });
  get responseTypeControl(): FormControl {
    return this.searchForm.get('responseType') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({
      responseType: this.responseTypeControl.value
    } as IntelligenceSearchInterface);
  }

  clean(): void {
    this.responseTypeControl.setValue(null);
    this.search.emit({} as IntelligenceSearchInterface);
  }

}
